// src/components/PopupAfiliado.tsx

import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonSiguiente } from "@/components/ui";

const PopupAfiliado: FC = () => {
  const navigate = useNavigate();

  const opciones = [
    {
      titulo: "Crear Afiliado",
      ruta: "/crearAfiliado",
      color: "bg-green-600 hover:bg-green-700",
    },
    {
      titulo: "Editar Afiliado",
      ruta: "/editarAfiliado",
      color: "bg-yellow-500 hover:bg-yellow-600",
    },
    {
      titulo: "Dar de Baja/Activar",
      ruta: "/bajaAfiliado",
      color: "bg-red-600 hover:bg-red-700",
    },
    {
      titulo: "Ver Resumen",
      ruta: "/resumenAfiliado",
      color: "bg-blue-600 hover:bg-blue-700",
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="absolute left-4 top-4">
        <ButtonSiguiente
          onClick={() => navigate("/backoffice")}
          className="rounded-lg bg-gray-200 px-4 py-2 shadow hover:bg-gray-300"
        >
          ⬅ Volver
        </ButtonSiguiente>
      </div>

      <div className="flex w-full max-w-3xl flex-col gap-6 rounded-xl border-r-4 border-t-2 border-zinc-600 bg-zinc-400 p-6 text-zinc-700 shadow-md shadow-orange-700">
        <h2 className="text-center text-2xl font-bold">
          Gestión de Afiliados
        </h2>

        <div className="grid grid-cols-12 gap-4">
          {opciones.map((opcion) => (
            <button
              key={opcion.ruta}
              type="button"
              onClick={() => navigate(opcion.ruta)}
              className={`col-span-12 rounded-lg border-b-2 border-r-4 p-4 text-white transition sm:col-span-6 ${opcion.color}`}
            >
              {opcion.titulo}
            </button>
          ))}

          <button
            type="button"
             onClick={() => navigate("/promocionesGenerales")}
            className="col-span-12 rounded-lg border-b-2 border-r-4 border-purple-900 bg-purple-700 p-4 font-semibold text-white transition hover:bg-purple-800"
          >
            🎟️ Gestionar Códigos Promocionales
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupAfiliado;